/**
 * @generated SignedSource<<7b6646f170b1f0c324354baff81b81b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type promoTracking_promotion$data = {
  readonly linkData: {
    readonly path: string | null;
  };
  readonly " $fragmentType": "promoTracking_promotion";
};
export type promoTracking_promotion$key = {
  readonly " $data"?: promoTracking_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"promoTracking_promotion">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "promoTracking_promotion"
};

(node as any).hash = "8fb7956a7ddf136b963317238bb5545e";

export default node;
